export const GROUPNAME_UNDEFINED_ERR_MSG = "Invalid metadata: GroupName not defined in the metadata. Please contact system admin.";
export const NO_GROUPS_DETECTED_ERR_MSG = "No groups detected in the step's metadata, please contact your administrator.";
export const SELECT_GROUPS_TEXT_PLACEHOLDER = "Select group";
export const DISPLAY_GROUPS_TEXT_PLACEHOLDER = "Display groups";
export const DEFAULT_RECIPIENT_LABEL = "Select recipient";
export const ADD_ALL_GROUPS_BTN_PLACEHOLDER = "Select all from group";
export const GET_RECIPIENTS_EXPAND_PARAM = "groups";
export const COMPONENT_NAME = "recipient-list-filter-filter";
export const NO_RECIPIENT_SELECTED_ERR_MSG = "Please make a selection from the drop down before adding.";
